import React from 'react';
import Classnames from 'classnames';

function InteractiveStatesButton({
    iconInactiveCls = 'icon-Chair_OFF', iconActiveCls = 'icon-Chair_ON', iconDisabledCls = 'icon-Chair_Overlap',
    iconLoadingCls= 'interactive-states-button--loading', disabled, active, backgroundColor, text, onClick, loading
}) {
    const cls = Classnames('interactive-states-button',
        {'interactive-states-button--active': active},
        {'interactive-states-button--disabled': disabled});
    const clcText = Classnames('interactive-states-button__text',
        {'color-1': active});
    const clsIcon = Classnames('interactive-states-button__icon custom-color',
        {[`${iconInactiveCls} color-1`]: !active && !disabled && !loading},
        {[`${iconActiveCls} color-1`]: active && !loading},
        {[`${iconDisabledCls}`]: disabled},
        {[`${iconLoadingCls}`]: loading});

    const style = active ? {backgroundColor} : null;
    const clickCallback = !disabled ? onClick : null;
    return (<div onClick={clickCallback} className={cls} style={style}>
        <i className={clsIcon}/>
        <span className={clcText}>{text}</span>
    </div>);
}

export default InteractiveStatesButton;
